import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { Outlet, useLocation } from "react-router-dom";
import ModalLayout from "../Pages/ModalLayout";

function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return isMobile ? <Outlet /> : <ModalLayout />
}

export default ScrollTop;
